/**
 * Main Navbar Component
 *
 */

import { FC, ReactNode } from "react";
import { NavOuterContainer } from "./styling/navbar.styles";

interface Props {
  className?: string;
}

const Navbar:FC<Props> = (props) => {
  return <NavOuterContainer className={props.className} />;
};

export default Navbar;
